export const START_MONTH = 3; // April
export const NUM_MONTHS = 12;
